import CloseIcon from "@mui/icons-material/Close";
import type { Theme } from "@mui/material";
import { Typography } from "@mui/material";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { BetaChip } from "@citrine/atoms/chips";
import { IconButton } from "@citrine/atoms/icon-button";
import { CatalystIcon } from "@citrine/atoms/icons";
import { Row } from "@citrine/atoms/layout";

import { useCatalystContext } from "#src/contexts/catalyst";

import * as sx from "./catalyst-header.sx";
import { LiteratureExpertChip } from "./literature-expert-chip";
import { ModeSelector } from "./mode-selector";

const getBottomBorder = (theme: Theme) => `1px solid ${theme.palette.divider}`;

export function CatalystHeader({
  controls,
  disabled,
  subheader,
}: {
  controls?: ReactNode;
  disabled: boolean;
  subheader?: ReactNode;
}) {
  const { agentEnabled, mode, modelExpertEnabled, setExpanded, setMode } =
    useCatalystContext();

  return (
    <sx.Container
      sx={subheader ? { borderBottom: getBottomBorder } : undefined}
    >
      <sx.CardHeader
        action={
          <Row>
            <Row sx={{ gap: 1 }}>
              {modelExpertEnabled || agentEnabled ? (
                <ModeSelector
                  agentEnabled={agentEnabled}
                  disabled={disabled}
                  modelExpertEnabled={modelExpertEnabled}
                  onChange={setMode}
                  value={mode}
                />
              ) : (
                <LiteratureExpertChip />
              )}
              {controls ? <>{controls}</> : null}
            </Row>
            <IconButton
              data-fullstoryid="catalyst.close-button"
              onClick={() => setExpanded(false)}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Row>
        }
        title={
          <Row sx={{ gap: 1 }}>
            <CatalystIcon fontSize="large" />
            <Typography variant="h3">
              <FormattedMessage id="catalyst.title" />
            </Typography>
            <BetaChip variant="outlined" />
          </Row>
        }
      />
      {subheader ? <>{subheader}</> : null}
    </sx.Container>
  );
}
